import { useRef } from 'react';

import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';
import { VisibilityOffOutlined } from '@mui/icons-material';
import { Popper } from '@mui/material';
import { useAtom } from 'jotai';

import { PreferenceButton } from '../../../common-components/composed/preferenceButton/PreferenceButton';
import { mixpanelEvents, useTrackEvent } from '../../../utils/mixpanel';

import { hiddenAnnotationsAtom, selectedAnnotationAtom } from './atoms';

const StyledPopper = styled(Popper)`
  border-radius: 0.25em;
  background: white;
  padding: 0.5em;
  button {
    border: 0;
    white-space: nowrap;
    gap: 0.5em;
  }
`;

const StyledPopperLocationDiv = styled.div<{ coordinates?: [string, string] }>`
  position: absolute;
  left: ${({ coordinates }) => coordinates && coordinates[0]}px;
  top: ${({ coordinates }) => coordinates && coordinates[1]}px;
`;

export const AnnotationSelectedPopup = () => {
  const [selectedAnnotation, setSelectedAnnotation] = useAtom(
    selectedAnnotationAtom,
  );
  const [hiddenAnnotations, setHiddenAnnotations] = useAtom(
    hiddenAnnotationsAtom,
  );
  const selectedAnnotationImage = selectedAnnotation.activeImage;
  const popperLocation = useRef<HTMLDivElement>(null);

  const { trackEvent } = useTrackEvent();
  return (
    <>
      <StyledPopperLocationDiv
        ref={popperLocation}
        coordinates={selectedAnnotation.coordinates}
      />
      <StyledPopper
        open={!!selectedAnnotation.selectedAnnotation.length}
        anchorEl={popperLocation.current}
      >
        <PreferenceButton
          onClick={() => {
            setHiddenAnnotations([
              ...hiddenAnnotations,
              selectedAnnotation.selectedAnnotation,
            ]);
            setSelectedAnnotation({ selectedAnnotation: '' });
            trackEvent(mixpanelEvents.casePresentationHideFinding, {
              annotationUuid: selectedAnnotation.selectedAnnotation,
              patientId: selectedAnnotationImage?.patientInfo.id,
              detectedImageType: selectedAnnotationImage?.detectedImageType,
              estimatedVisitId: selectedAnnotationImage?.estimatedVisitId,
              image: selectedAnnotationImage?.imageId,
            });
          }}
        >
          <VisibilityOffOutlined /> <Trans>Hide Finding</Trans>
        </PreferenceButton>
      </StyledPopper>
    </>
  );
};
